import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import users from '../../../../users';
import { validationMixin } from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';

export default {
  name: 'Quotations',
  mixins: [users, validationMixin],
  components: {
    QuotationComp: require('../quotation/quotation.vue').default,
  },
  validations: {
    dataObjQuotations: {
      $each: {
        name: {
          required,
        },
        quantity: {
          required,
          minValue: minValue(0)
        },
        rate: {
          required,
          minValue: minValue(0)
        },
      }
    },
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      quotations: [],
      rowsTotal: 0,
      deleteIndex: -1,
      bShowDeleteConfirm: false,

      editRowIdx: -1,

      editingQuotation: {},
      options: { pageSize: 5, total: 0, page: 1 },
      message: '',
      bShowQuotation: false,
      bShowConfirm: false,
      bShowActions: false,
      bInlineEditing: false,
      bSuppressMessage: false,
      action: null,
      actionRecord: null,
      totalRow: 0,
      iEditIndex: -1,
    }
  },
  computed: {
    dataObjQuotations() {
      return this.dataObj.items;
    },
  },
  watch: {
    dataObjQuotations: {
      handler: function (value) {
        this.getRowsTotal();
      },
      deep: true,
    },
    bInlineEditing: function (value) {
      this.iEditIndex = -1;
    },
    action: function () {
      this.bShowActions = false;
      switch (this.action) {
        case 'edit':
          this.editQ(this.actionRecord);
          break;
        case 'delete':
          this.deleteQ(this.actionRecord);
          break;
        case 'moveup':
          this.moveUp(this.actionRecord);
          break;
        case 'movedown':
          this.moveDown(this.actionRecord);
          break;
        default:
          break;
      }
      this.action = null;
      this.actionRecord = null;
    },
  },
  created() {
    this.appId = this.dataObj.appId;
    /*this.getQuotations();
    if (!this.$store.state.csAppsOfflineMode) {
      this.$root.$on('do_save_quotation', this.saveAll);
    }*/
    this.getRowsTotal();
  },
  methods: {
    getItemTotal(item) {
      let total = 0;

      let q = item.quantity == null ? 0 : (item.quantity <= 0 ? 0 : Number(item.quantity));
      let r = item.rate == null ? 0 : (item.rate <= 0 ? 0 : Number(item.rate));

      total = Number((q * r).toFixed(2));

      return Number(total.toFixed(2));
    },
    getRowsTotal() {
      this.rowsTotal = 0;

      for (let i = 0; i < this.dataObj.items.length; i++) {
        this.rowsTotal += this.getItemTotal(this.dataObj.items[i]);

        this.rowsTotal = Number(this.rowsTotal.toFixed(2));
      }
    },
    deleteQuotations(index) {
      this.deleteIndex = index;
      this.bShowDeleteConfirm = true;
    },
    deleteConfirmed() {
      if (this.dataObj.items[this.deleteIndex].sequence == -1) {
        this.dataObj.items.splice(this.deleteIndex, 1);
      } else {
        let parameters = {
          ApplicationId: this.dataObj.appId,
          ApplicationKey: 0,
          Sequence: this.dataObj.items[this.deleteIndex].sequence
        };

        axios.post('/QuotationActivity/DeleteQuotation', parameters)
          .then(response => {
            if (response.status == 200) {

              this.dataObj.items = response.data.items;
              this.getRowsTotal();
            }
            else
              this.$alertMsg(response.data.data.text);
          })
          .catch(err => {
            this.$alertMsg(err.response.data);
          });
      }
    },
    addQuotation() {
      this.dataObj.items.push({
        canDelete: true,
        canModifyCost: true,
        canModifyName: true,
        name: "(new)",
        quantity: null,
        rate: null,
        sequence: -1,
      });

      this.editRowIdx = this.dataObj.items.length - 1;
    },
    saveQuotation() {
      this.$v.dataObjQuotations.$touch();

      if (this.$v.dataObjQuotations.$invalid)
        return;

      let parameters = {
        ApplicationId: this.dataObj.appId,
        ApplicationKey: 0,
        Item: this.dataObj.items[this.editRowIdx]
      };


      axios.post('/QuotationActivity/InsertUpdateQuotation', parameters)
        .then(response => {
          if (response.status == 200) {
            this.dataObj.items = response.data.items;
            this.editRowIdx = -1;
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },


    
    getValidationClassQ(fieldName, index) {
      const field = this.$v.dataObjQuotations.$each[index][fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    validateAppData() {
      this.$v.dataObjQuotations.$touch();

      if (this.$v.dataObjQuotations.$invalid)
        return false;

      return true;
    },

    pageChange(pInfo) {
      this.getQuotations();
    },
    setAction(value) {
      this.bShowActions = true;
      this.actionRecord = value;
    },
    addQ() {
      this.editingQuotation = {
        applicationId: this.appId,
        seq: -1,
        name: '',
        rate: 0,
        quantity: 0,
      };
      this.$root.$emit('quotation_updated');
      this.bShowQuotation = true;
    },
    editQ(quotation) {
      this.bShowQuotation = true;
    },
    onBlur(event) {
      this.saveQuotation();
    },
    
    saveQuotationInline(quotation) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/QuotationActivity/InsertOrUpdateQuotation', { ApplicationId: this.appId, Item: quotation })
        .then(response => {
          if (response.status == 200) {
            this.getQuotations();
            this.$alertMsg(this.$t('messages.QuotationSavedSuccess'), 2);
            loader.hide();
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
    },
    saveAllInline(quotation) {
      axios.post('/QuotationActivity/InsertOrUpdateQuotation', { ApplicationId: this.appId, Item: quotation })
        .then(response => {
          if (quotation.seq < this.quotations.length) {
            this.saveAllInline(this.quotations[quotation.seq]);
          }
          else {
            this.$alertMsg(this.$t('messages.QuotationSavedSuccess'), 2);
          } 
        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    saveAll() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      this.saveAllInline(this.quotations[0]);
      setTimeout(function () { loader.hide(); }, 2000);
    },
    deleteQ(quotation) {
      this.deletionSeq = quotation.seq;
      this.bShowConfirm = true;
    },
    moveUp(quotation) {
      axios.post('/QuotationActivity/MoveQuotation', { ApplicationId: this.appId, Seq: quotation.seq, MoveUp: true })
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.QuotationMovedSuccess'), 2);
            this.getQuotations();
          }
        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    moveDown(quotation) {
      axios.post('/QuotationActivity/MoveQuotation', { ApplicationId: this.appId, Seq: quotation.seq, MoveUp: false })
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.QuotationMovedSuccess'), 2);
            this.getQuotations();
          }
        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    confirmDeleteYes() {
      this.bShowConfirm = false;
      axios.post('/QuotationActivity/DeleteQuotation', { ApplicationId: this.appId, Seq: this.deletionSeq })
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.QuotationDeletedSuccess'), 2);
            this.getQuotations();
          }
        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    confirmDeleteNo() {
      this.bShowConfirm = false;
    },
    closeDialog() {
      this.editingMessage = '';
      this.getQuotations();
      this.bShowQuotation = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getQuotations();
    },
  },
  
}

